import {
  AUTH_SESSION_BROADCAST_CHANNEL,
  AUTH_SESSION_EXPIRED_MESSAGE,
} from "@/constants";

type SessionExpiredHandler = () => void;

let handler: SessionExpiredHandler | null = null;
let notifying = false;

/** Syncs session-expiry logout across tabs; unsupported in very old browsers. */
const sessionBroadcastChannel =
  typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel(AUTH_SESSION_BROADCAST_CHANNEL)
    : null;

sessionBroadcastChannel?.addEventListener("message", (event) => {
  if (event.data === AUTH_SESSION_EXPIRED_MESSAGE) {
    triggerSessionExpiredHandler();
  }
});

export function registerSessionExpiredHandler(
  next: SessionExpiredHandler | null,
): void {
  handler = next;
  notifying = false;
}

function triggerSessionExpiredHandler(): void {
  if (notifying || !handler) {
    return;
  }
  notifying = true;
  handler();
}

/** Invoked by apiFetch (401) and other non-React auth checks. Notifies other open tabs. */
export function notifySessionExpired(): void {
  if (notifying) {
    return;
  }
  sessionBroadcastChannel?.postMessage(AUTH_SESSION_EXPIRED_MESSAGE);
  triggerSessionExpiredHandler();
}

/** True once a session-expiry logout has started; lets callers suppress unrelated error UI. */
export function isSessionExpired(): boolean {
  return notifying;
}
